import { createContext, useState, useContext } from "react";

const ViewPresentationContext = createContext();

export const useViewContext = () => useContext(ViewPresentationContext);

export const ViewContextProvider = ({ children }) => {
  const [slideAudioData, setSlideAudioData] = useState(null);
  const [showAudioPrompt, setShowAudioPrompt] = useState(true);

  return (
    <ViewPresentationContext.Provider value={{
      slideAudioData, setSlideAudioData,
      showAudioPrompt, setShowAudioPrompt,
    }}>
      {children}
    </ViewPresentationContext.Provider>
  )
}